<ng-template #inner>
  <span class="flex items-center gap-2">
    @if (loading) {
      <svg
        class="animate-spin h-4 w-4"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        >
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
      </svg>
    }

    <ng-content></ng-content>
  </span>
</ng-template>

@if (isLink) {
  @if (isRouterLink) {
    <a
      [routerLink]="(disabled || loading) ? null : routerLink"
      [queryParams]="queryParams"
      [fragment]="fragment"
      [attr.target]="target"
      [attr.rel]="computedRel"
      [attr.aria-disabled]="ariaDisabled"
      [attr.tabindex]="computedTabIndex"
      role="button"
      [ngClass]="computedClasses"
      (click)="onClick($event)"
      >
      <ng-container [ngTemplateOutlet]="inner"></ng-container>
    </a>
  } @else {
    <a
      [attr.href]="(disabled || loading) ? null : href"
      [attr.target]="target"
      [attr.rel]="computedRel"
      [attr.aria-disabled]="ariaDisabled"
      [attr.tabindex]="computedTabIndex"
      role="button"
      [ngClass]="computedClasses"
      (click)="onClick($event)"
      >
      <ng-container [ngTemplateOutlet]="inner"></ng-container>
    </a>
  }
} @else {
  <button
    [type]="type"
    [disabled]="disabled || loading"
    [ngClass]="computedClasses"
    (click)="onClick($event)"
    >
    <ng-container [ngTemplateOutlet]="inner"></ng-container>
  </button>
}
